import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already given consent
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Show banner after a short delay for better UX
      setTimeout(() => setShowBanner(true), 1000);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('cookieConsent', 'all');
    setShowBanner(false);
  };

  const handleAcceptNecessary = () => {
    localStorage.setItem('cookieConsent', 'necessary');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-dark-100 border-t border-gray-700 shadow-2xl animate-slide-up">
      <div className="container mx-auto max-w-6xl">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex-1">
            <h3 className="text-white font-semibold mb-2 flex items-center">
              <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
                <path fillRule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z" clipRule="evenodd" />
              </svg>
              Cookie & Privacy Notice
            </h3>
            <p className="text-gray-400 text-sm mb-3">
              We use cookies and similar technologies to enhance your experience, analyze site traffic, and personalize content. 
              By clicking "Accept All", you consent to our use of cookies.
            </p>
            <div className="flex flex-wrap gap-2 text-xs">
              <Link 
                to="/privacy-policy" 
                className="text-primary hover:text-primary-light transition-colors duration-200"
                onClick={() => setShowBanner(false)}
              >
                Privacy Policy
              </Link>
              <span className="text-gray-600">•</span>
              <Link 
                to="/cookie-policy" 
                className="text-primary hover:text-primary-light transition-colors duration-200"
                onClick={() => setShowBanner(false)}
              >
                Cookie Policy
              </Link>
              <span className="text-gray-600">•</span>
              <Link 
                to="/terms-of-service" 
                className="text-primary hover:text-primary-light transition-colors duration-200"
                onClick={() => setShowBanner(false)}
              >
                Terms of Service
              </Link>
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
            <button
              onClick={handleAcceptNecessary}
              className="px-6 py-2.5 bg-dark-200 text-gray-300 rounded-lg hover:bg-dark-300 transition-colors duration-200 text-sm font-medium border border-gray-700"
            >
              Necessary Only
            </button>
            <button
              onClick={handleAcceptAll}
              className="px-6 py-2.5 bg-primary text-white rounded-lg hover:bg-primary-light transition-colors duration-200 text-sm font-medium shadow-lg"
            >
              Accept All
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
